/*
 * EMEDEMORA · Vitrina de los relojes en existencia (sections/emd-vitrina.liquid).
 *
 * El carrusel de la página de Star Wars de Ben & Frank, con relojes: el del centro grande y nítido, el anterior y el
 * siguiente chicos y desenfocados a los lados, y el nombre y el precio del de en medio. Se mueve con las flechas, con
 * un clic en el reloj de un lado, deslizando el dedo, con las flechas del teclado y con la fila de miniaturas.
 * También cambia el texto de la entrada por las fechas exactas de llegada (5 a 7 días hábiles; si cae en fin de
 * semana, el lunes), las mismas que calcula el armador de la ficha. Sin JavaScript queda una fila con desplazamiento.
 */
if (!customElements.get('emd-vitrina')) {
  const formato = new Intl.DateTimeFormat('es-MX', { weekday: 'long', day: 'numeric', month: 'long' });
  const habiles = (desde, dias) => {
    const f = new Date(desde);
    let quedan = dias;
    while (quedan > 0) {
      f.setDate(f.getDate() + 1);
      if (f.getDay() !== 0 && f.getDay() !== 6) quedan -= 1;
    }
    return f;
  };
  const fecha = (f) => formato.format(f).replace(',', '');
  const ESTADOS = ['es-actual', 'es-antes', 'es-despues', 'es-lejos-izq', 'es-lejos-der'];
  const sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)');

  class EmdVitrina extends HTMLElement {
    connectedCallback() {
      if (this.iniciada) return;
      this.iniciada = true;
      this.piezas = [...this.querySelectorAll('[data-emd-v-pieza]')];
      this.lista = this.querySelector('.emd-v-lista');
      this.aviso = this.querySelector('[data-emd-v-aviso]');
      this.ponerFechas();
      if (this.piezas.length < 2) return;

      this.lista.classList.add('emd-v-listo', 'emd-v-quieto');
      this.querySelectorAll('[data-emd-v-mover]').forEach((b) => {
        b.hidden = false;
        b.addEventListener('click', () => this.ir(this.actual + Number(b.dataset.emdVMover)));
      });
      this.armarFila();
      // el reloj de un lado se trae al centro en vez de abrir su ficha
      this.lista.addEventListener('click', (ev) => {
        const foto = ev.target.closest('.emd-v-foto');
        if (!foto) return;
        const i = this.piezas.indexOf(foto.closest('[data-emd-v-pieza]'));
        if (i !== this.actual) {
          ev.preventDefault();
          this.ir(i);
        }
      });
      this.addEventListener('keydown', (ev) => {
        // Alt+← y Cmd+← son «Atrás» del navegador: esos no se tocan
        if (ev.altKey || ev.ctrlKey || ev.metaKey || ev.target.closest('input, textarea, select')) return;
        if (ev.key === 'ArrowLeft') this.ir(this.actual - 1);
        else if (ev.key === 'ArrowRight') this.ir(this.actual + 1);
        else return;
        ev.preventDefault();
      });
      this.deslizar();
      // la primera posición va de golpe, sin transición (emd-v-quieto, puesto arriba): si no, al cargar los vecinos salen
      // volando desde el centro, y si la ventana no pinta cuadros se quedan apilados
      this.ir(0, false);
      void this.lista.offsetWidth;
      requestAnimationFrame(() => requestAnimationFrame(() => this.lista.classList.remove('emd-v-quieto')));
    }

    ponerFechas() {
      const el = this.querySelector('[data-emd-v-entrega]');
      if (!el) return;
      const hoy = new Date();
      // Mario (2026-10-19): en existencia llega en 5 a 7 días hábiles
      const a = habiles(hoy, 5);
      const b = habiles(hoy, 7);
      const rango = `Pídelo hoy y llega entre el ${fecha(a)} y el ${fecha(b)}.`;
      const resto = el.textContent.trim();
      el.textContent = resto ? `${rango} ${resto}` : rango;
    }

    armarFila() {
      const fila = this.querySelector('[data-emd-v-fila]');
      if (!fila) return;
      this.minis = this.piezas.map((p, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'emd-v-mini';
        b.setAttribute('aria-label', `${p.dataset.modelo} ${p.dataset.color}`);
        const img = document.createElement('img');
        img.alt = '';
        img.width = 66;
        img.height = 92;
        img.loading = 'lazy';
        img.addEventListener('error', () => {
          if (img.dataset.respaldo) return;
          img.dataset.respaldo = '1';
          img.src = p.dataset.miniRespaldo;
        });
        img.src = p.dataset.mini;
        b.append(img);
        b.addEventListener('click', () => this.ir(i));
        fila.append(b);
        return b;
      });
      fila.hidden = false;
      this.fila = fila;
    }

    // deslizar con el dedo (o el ratón): más de 40 px de lado, y más de lado que de alto. El gesto de lado es de la
    // vitrina por el touch-action: pan-y de emd-vitrina.css; sin él, el navegador lo toma y manda pointercancel.
    deslizar() {
      let x0 = null;
      let y0 = 0;
      this.lista.addEventListener('pointerdown', (ev) => {
        if (ev.pointerType === 'mouse' && ev.button !== 0) return;
        x0 = ev.clientX;
        y0 = ev.clientY;
        // tras deslizar con el dedo no llega clic: que la marca no se coma el toque siguiente
        this.arrastro = false;
      }, { passive: true });
      // con el ratón, Chrome arrastraría el enlace o la foto en vez de mover la vitrina
      this.lista.addEventListener('dragstart', (ev) => ev.preventDefault());
      const soltar = (ev) => {
        if (x0 === null) return;
        const dx = ev.clientX - x0;
        const dy = ev.clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          this.arrastro = true;
          this.ir(this.actual + (dx < 0 ? 1 : -1));
        }
      };
      this.lista.addEventListener('pointerup', soltar, { passive: true });
      this.lista.addEventListener('pointercancel', () => { x0 = null; }, { passive: true });
      // un arrastre no es un clic: que no abra la ficha al soltar
      this.lista.addEventListener('click', (ev) => {
        if (this.arrastro) {
          this.arrastro = false;
          ev.preventDefault();
          ev.stopPropagation();
        }
      }, true);
    }

    ir(i, anunciar = true) {
      const n = this.piezas.length;
      // si el foco está en el reloj que se va, su botón deja de alcanzarse: el foco pasa al que llega
      const conFoco = this.piezas.find((p) => p.contains(document.activeElement));
      this.actual = ((i % n) + n) % n;
      this.piezas.forEach((p, k) => {
        const d = (((k - this.actual) % n) + n) % n;
        let estado = 'es-lejos-der';
        if (d === 0) estado = 'es-actual';
        else if (d === 1) estado = 'es-despues';
        else if (d === n - 1) estado = 'es-antes';
        else if (d > n / 2) estado = 'es-lejos-izq';
        p.classList.remove(...ESTADOS);
        p.classList.add(estado);
        const visible = d === 0;
        p.setAttribute('aria-hidden', String(!visible));
        p.querySelectorAll('a').forEach((a) => {
          a.tabIndex = visible && a.classList.contains('emd-v-ver') ? 0 : -1;
        });
      });
      if (this.minis) {
        this.minis.forEach((b, k) => b.setAttribute('aria-current', String(k === this.actual)));
        const b = this.minis[this.actual];
        // solo la fila se desplaza de lado: la página no se mueve
        if (this.fila && this.fila.scrollWidth > this.fila.clientWidth) {
          this.fila.scrollTo({
            left: b.offsetLeft - (this.fila.clientWidth - b.offsetWidth) / 2,
            behavior: sinMovimiento.matches ? 'auto' : 'smooth',
          });
        }
      }
      if (conFoco && conFoco !== this.piezas[this.actual]) {
        const ver = this.piezas[this.actual].querySelector('.emd-v-ver');
        if (ver) ver.focus({ preventScroll: true });
      }
      if (anunciar && this.aviso) {
        const p = this.piezas[this.actual];
        this.aviso.textContent = `${p.dataset.modelo} ${p.dataset.color}, ${this.actual + 1} de ${n}`;
      }
    }
  }
  customElements.define('emd-vitrina', EmdVitrina);
}
